<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="500px"
    append-to-body
    :show-close="closeable"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="pwd"
      :rules="rules"
      label-width="90px">
      <el-form-item
        label="初始密码:"
        prop="oldPassword">
        <el-input
          v-model="pwd.oldPassword"
          type="password"></el-input>
      </el-form-item>
      <el-form-item
        label="新设密码:"
        prop="newPassword">
        <el-input
          v-model="pwd.newPassword"
          type="password"></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码:"
        prop="cNewPassword">
        <el-input
          v-model="pwd.cNewPassword"
          type="password"></el-input>
      </el-form-item>
      <el-alert
        v-if="!closeable"
        title="首次登录，请修改密码！"
        type="warning"
        :closable="false">
      </el-alert>
    </el-form>
    <span slot="footer">
      <el-button
        v-if="closeable"
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { navigateToLogin } from '../../utils/navigateToLogin'
export default {
  name: 'PasswordModal',
  props: {
    account: { type: [String, undefined], required: true },
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      closeable: true,
      pwd: { oldPassword: '', newPassword: '', cNewPassword: '' },
      rules: {
        oldPassword: [
          { required: true, message: '请输入初始密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新设密码', trigger: 'blur' }
          // {
          //   pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_@#$%^&*!]{6,12}$/, //  /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z\@\#\$\%\^\&\*\_\!]{6,12}$/,
          //   message: '密码须包含数字和字母，可选符号@#$%^&*_!，长度为6-12',
          //   trigger: 'blur'
          // }
        ],
        cNewPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.pwd.newPassword) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    forceUpdate() {
      this.visible = true
      this.closeable = false
    },
    handleClose() {
      this.closeable = true
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('account/modifypassword', {
            payload: { account: this.account, oldPassword: this.pwd.oldPassword, newPassword: this.pwd.newPassword },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('密码修改成功,请重新登录')
              setTimeout(() => {
                navigateToLogin()
                // this.$store.commit('account/reset')
                // this.$router.push({ path: '/login' })
              }, 1500)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
